module.exports = __webpack_public_path__ + "static/media/icon-select-off.787c7544.svg";